import moment from 'moment'

//Format
export const dayMonthYearFormat = (dateTime) => {
  return moment(dateTime, 'YYYY-MM-DDTHH:mm:ss Z').format('MM/DD/YYYY')
}

export const dateTimeTimezoneFormat = (dateTime) => {
  return moment(dateTime, 'YYYY-MM-DDTHH:mm:ss Z').format(
    'MM/DD/YYYYTHH:mm:ss Z'
  )
}

export const dateFormat = (dateTime) => {
  return moment(dateTime, 'YYYY-MM-DD').format('MM/DD/YYYY')
}

export const dateTimeFormat = (dateTime) => {
  return moment(dateTime, 'YYYY-MM-DDTHH:mm:ss Z').format('MM/DD/YYYY - hh:mmA')
}

export const detailedDateTimeFormat = (dateTime) => {
  return moment(dateTime, 'YYYY-MM-DDTHH:mm:ss Z').format(
    'MMM D, YYYY - h:mm A'
  )
}

export const detailedDateFormat = (dateTime) => {
  return moment(dateTime, 'YYYY-MM-DDTHH:mm:ss Z').format('MMM D, YYYY')
}

export const iso8601Format = (dateTime) => {
  return moment(dateTime, 'MM/DD/YYYYTHH:mm:ss Z')
    .local()
    .format('YYYY-MM-DDTHH:mm:ss Z')
}

export const iso8601DateFormat = (dateTime) => {
  return moment(dateTime, 'MM/DD/YYYY').format('YYYY-MM-DD')
}

export const displayMMDDYYYY = (dateTime) => {
  if (!dateTime) return null
  return moment(dateTime, 'MMDDYYYY').format('MM-DD-YYYY')
}

export const displayHHMMSS = (dateTime) => {
  if (!dateTime) return null
  return moment(dateTime, 'HHmmss').format('HH:mm:ss')
}

//Display
export const utcToLocalDate = (date) => {
  const localDateTime = moment.utc(date).local()
  return dayMonthYearFormat(localDateTime)
}

export const utcToLocalDateTime = (dateTime) => {
  const localDateTime = moment.utc(dateTime).local()
  return dateTimeFormat(localDateTime)
}

export const utcToLocalDateTimeFormat = (dateTime) => {
  const localDateTime = moment.utc(dateTime).local()
  return detailedDateTimeFormat(localDateTime)
}

export const utcToLocalDetailedDate = (dateTime) => {
  const localDateTime = moment.utc(dateTime).local()
  return detailedDateFormat(localDateTime)
}
